<template>
	<div class="kiinara-home">
		<div class="kiinara-home__header kiinara-animation-slide-up">
			<img src="../../design-system/media/logos/kiinara_light.svg" />
		</div>

		<div class="kiinara-home__content kiinara-animation-late-slide-up">
			<div class="kiinara-home__content--title">Helping businesses/societies with our Rich Solutions and Technical Expertise.</div>
			<div class="kiinara-home__content--coming-soon">
				<span>Coming Soon</span> <a href="mailto:info@kiinara.com">info@kiinara.com</a>
			</div>
		</div>

		<background-particle />
	</div>
</template>

<script>
	import BackgroundParticle from '../components/particles/BackgroundParticle';

	export default {
		components: {
			BackgroundParticle,
		}
	}
</script>

<style lang="scss" scoped>
	.kiinara-home {
		background: linear-gradient(to left, $dark, rgba(0, 0, 0, 1));
		width: 100%;
		padding: 3em 4em;

		display: flex;
		flex-direction: column;
		justify-content: center;

		&__header {
			margin-bottom: 4em;
			img {
				width: 150px;
			}
		}

		&__content {
			margin-bottom: 2em;
			&--title {
				font-size: 2.8em;
				font-family: 'SegoeUIItalic', 'SegoeUI', sans-serif;
				font-style: italic;
				margin-bottom: 1em;
				display: block;
				max-width: 800px;
			}

			&--coming-soon {
				font-size: 1.2em;
				display: flex;
				align-items: center;

				span {
					padding-right: 1em;
					position: relative;
					margin-right: 1em;
					&:after {
						content: "";
						@include box(4px);
						background: $white;
						position: absolute;
						@include centerY();
						right: 0;
						border-radius: 50%;
					}
				}

				a {
					color: $accent;
					text-decoration: none;
				}
			}
		}
	}
</style>
